module.exports = __webpack_public_path__ + "static/media/topbar-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brands/png/mhi/topbar-logo.png
// module id = 2712
// module chunks = 0